export default __webpack_public_path__ + "static/media/noti_icon.3119d89e.svg";